import SelectCategoriesForm from './SelectCategoriesForm'
export default SelectCategoriesForm
